import React from 'react';

import { useViewType, ViewType } from '@eika/hooks';

import LoanActionLinks from '../../components/LoanActionLinks/LoanActionLinks';
import LoanActions from '../../components/LoanActions/LoanActions';
import useAccountId from '../../hooks/useAccountId';
import { useLoanDetails } from '../../hooks/useLoans';

import './LoanAccountActions.scss';

const LoanAccountActions: React.FC = () => {
    const viewType = useViewType();
    const accountId = useAccountId();
    const { data: details, isLoading } = useLoanDetails(accountId);

    if (viewType !== ViewType.desktop) {
        return null;
    }

    if (!details && !isLoading) {
        return null;
    }

    return (
        <>
            <LoanActions
                accountId={accountId}
                className="loan-account-actions"
                billingSummary={details?.billingSummary}
                isDesktop
                isLoading={isLoading}
            />
            <LoanActionLinks />
        </>
    );
};

export default LoanAccountActions;
